// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

/**
 * We don't use TypographyPresentationProps, because we need to inject style by css
 */
interface OrderInformationStyles {
    label?: StyledProp<any>;
    value?: StyledProp<any>;
    labelWithDots?: StyledProp<any>;
    headingAndTextStyles?: SmallHeadingAndTextStyles;
    address?: { heading?: TypographyPresentationProps } & AddressInfoDisplayStyles;
    orderSummary?: any;
}

const xOrderInformationStyles: OrderInformationStyles = {
    label: css`
        font-weight: bold;
        font-size: 12px;
        margin-right: 10px;
        line-height: 18px;
        white-space: nowrap;
        text-transform: capitalize;
    `,
    value: css`
        font-size: 12px;
        line-height: 18px;
        white-space: nowrap;
        &:empty:after {
            content: "#";
        }
    `,
};

xOrderInformationStyles.labelWithDots = css`
    ${xOrderInformationStyles.label}
    &:after {
        content: ":";
    }
`;

xOrderInformationStyles.headingAndTextStyles = {
    wrapper: {
        css: css`
            display: flex;
            &&& {
                @media print {
                    display: flex;
                }
            }
        `,
    },
    heading: {
        css: css`
            ${xOrderInformationStyles.labelWithDots}
        `,
    },
    text: {
        css: css`
            ${xOrderInformationStyles.value}
        `,
    },
};

xOrderInformationStyles.address = {
    heading: {
        variant: "h5",
    },
};

xOrderInformationStyles.orderSummary = {
    css: css`
        ${xScreen("lte", "md")} {
            margin-bottom: 10px;
        }
    `,
};

export default xOrderInformationStyles;
